import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GOOGLE_TAG;

export default function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag || !GA_ID) return;

        window.gtag('config', GA_ID, {
            page_path: location.pathname + location.search,
        });
    }, [location.pathname, location.search]);

    return null;
}
